{
  "name": "yamlresume",
  "version": "0.4.2",
  "description": "The CLI interface for YAMLResume's engine",
  "license": "MIT",
  "author": {
    "name": "YAMLResume",
    "email": "support@yamlresume.com",
    "url": "https://yamlresume.dev"
  },
  "keywords": [
    "YAMLResume",
    "CV",
    "Resume",
    "LaTeX",
    "Typesetting",
    "PDF",
    "YAML",
    "JSON"
  ],
  "type": "module",
  "bin": {
    "yamlresume": "./dist/cli.js"
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE",
    "resources/resume.yml"
  ],
  "scripts": {
    "build": "tsup",
    "build:watch": "tsup --watch",
    "build:clean": "rm -rf dist",
    "build:prod": "tsup --dts --minify --sourcemap",
    "prepublishOnly": "pnpm test",
    "dev": "tsx src/cli.ts",
    "test": "vitest --run",
    "test:cov": "vitest --coverage --run",
    "test:watch": "vitest"
  },
  "dependencies": {
    "@yamlresume/core": "workspace:*",
    "commander": "^11.0.0",
    "consola": "^3.4.2",
    "extensionless": "^1.9.9",
    "lodash-es": "^4.17.21",
    "markdown-table": "^3.0.4",
    "tslib": "^2.8.1",
    "which": "^5.0.0",
    "yaml": "^2.7.1"
  },
  "devDependencies": {
    "@types/commander": "^2.12.5",
    "@types/lodash-es": "^4.17.12",
    "@types/which": "^3.0.4",
    "tsx": "^4.19.3"
  },
  "publishConfig": {
    "access": "public"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/yamlresume/yamlresume.git",
    "directory": "packages/cli"
  },
  "bugs": {
    "url": "https://github.com/yamlresume/yamlresume/issues"
  },
  "homepage": "https://github.com/yamlresume/yamlresume/tree/main/packages/cli#readme",
  "engines": {
    "node": ">=20.0.0"
  }
}
